<page-title title="Dados de acesso"></page-title>

<page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
<page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

<form [formGroup]="form">
  <div class="row">
    <!-- Foto do perfil - Imagem à esquerda -->
    <div class="col-xs-12 col-md-3">
      <div class="photo-upload text-center">
        <div *ngIf="profilePictureUrl" class="preview">
          <img [src]="profilePictureUrl" alt="Foto de perfil" class="profile-picture-preview" />
        </div>
        <button mat-raised-button color="primary" (click)="fileInput.click()">Escolher Foto</button>
        <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" style="display: none" />

         <mat-error  *ngIf="form.get('photo')?.hasError('maxFileSize') ">
          O arquivo deve ter um tamanho menor que 4mb
        </mat-error>

        <mat-error  *ngIf="form.get('photo')?.hasError('invalidFileType') ">
          Permitido apenas imagems em png e jpeg 
        </mat-error>

      </div>
    </div>

    <!-- Formulário -->
    <div class="col-xs-12 col-md-9">
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input type="text" matInput formControlName="name" placeholder="Nome" required />
            <mat-error *ngIf="form.get('name')?.hasError('required')"> Campo obrigatório </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xs-12 col-md-6">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Nome Fantasia</mat-label>
            <input type="text" matInput formControlName="alias" placeholder="Nome Fantasia" required />
            <mat-error *ngIf="form.get('alias')?.hasError('required')"> Campo obrigatório </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xs-12 col-md-6">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>CNPJ</mat-label>
            <input type="text" matInput formControlName="cnpj" placeholder="CNPJ" mask="00.000.000/0000-00" required />
            <mat-error *ngIf="form.get('cnpj')?.hasError('required')"> Campo obrigatório </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xs-12 col-md-6">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Responsável legal</mat-label>
            <input type="text" matInput formControlName="legal_representative" placeholder="Responsável legal" required />
            <mat-error *ngIf="form.get('legal_representative')?.hasError('required')"> Campo obrigatório </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>


    <!-- Botões -->
    <div class="col-xs-12 btCriar">
      <button mat-flat-button color="primary" [disabled]="form.invalid"  *ngIf="mode == 'UPDATE'" (click)="save()">Salvar</button>
      <button mat-flat-button color="primary" [disabled]="form.invalid" *ngIf="mode == 'CREATE'" (click)="create()">Criar Conta</button>
    </div>
  </div>
</form>
